export default "__VITE_ASSET__a496eb4f__"